var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFinalSalesInvoiceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.333984,
    width: 36,
    height: 36,
    rx: 18,
    fill: "#EFE7FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.7476 10C23.8568 10 23.1348 12.149 23.1348 14.8H24.7476C25.5248 14.8 25.9135 14.8 26.154 14.5316C26.3947 14.2633 26.3528 13.9099 26.269 13.203C26.0479 11.3371 25.4502 10 24.7476 10Z",
    stroke: "#6929E2",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.134 14.8434V23.3166C23.134 24.526 23.134 25.1306 22.7644 25.3686C22.1605 25.7577 21.2269 24.9419 20.7573 24.6458C20.3693 24.4011 20.1753 24.2788 19.96 24.2718C19.7273 24.2641 19.5299 24.3814 19.1107 24.6458L17.582 25.6099C17.1696 25.8699 16.9634 26 16.734 26C16.5046 26 16.2984 25.8699 15.886 25.6099L14.3573 24.6458C13.9693 24.4011 13.7753 24.2788 13.56 24.2718C13.3274 24.2641 13.1299 24.3814 12.7107 24.6458C12.2411 24.9419 11.3075 25.7577 10.7035 25.3686C10.334 25.1306 10.334 24.526 10.334 23.3166V14.8434C10.334 12.5602 10.334 11.4186 11.0369 10.7093C11.7399 10 12.8712 10 15.134 10H24.734",
    fill: "#6929E2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.134 14.8434V23.3166C23.134 24.526 23.134 25.1306 22.7644 25.3686C22.1605 25.7577 21.2269 24.9419 20.7573 24.6458C20.3693 24.4011 20.1753 24.2788 19.96 24.2718C19.7273 24.2641 19.5299 24.3814 19.1107 24.6458L17.582 25.6099C17.1696 25.8699 16.9634 26 16.734 26C16.5046 26 16.2984 25.8699 15.886 25.6099L14.3573 24.6458C13.9693 24.4011 13.7753 24.2788 13.56 24.2718C13.3274 24.2641 13.1299 24.3814 12.7107 24.6458C12.2411 24.9419 11.3075 25.7577 10.7035 25.3686C10.334 25.1306 10.334 24.526 10.334 23.3166V14.8434C10.334 12.5602 10.334 11.4186 11.0369 10.7093C11.7399 10 12.8712 10 15.134 10H24.734",
    stroke: "#6929E2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7348 14.8C15.8511 14.8 15.1348 15.3373 15.1348 16C15.1348 16.6627 15.8511 17.2 16.7348 17.2C17.6184 17.2 18.3348 17.7373 18.3348 18.4C18.3348 19.0627 17.6184 19.6 16.7348 19.6M16.7348 14.8C17.4314 14.8 18.024 15.1339 18.2437 15.6M16.7348 14.8V14M16.7348 19.6C16.0381 19.6 15.4455 19.2661 15.2258 18.8M16.7348 19.6V20.4",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinalSalesInvoiceIcon);
export default __webpack_public_path__ + "static/media/final_sales_invoice_icon.7cb31a205e60c22b7476034466514d95.svg";
export { ForwardRef as ReactComponent };